import { Schema } from "prosemirror-model";

const pmSchemaJson = {
  topNode: "doc",
  nodes: {
    paragraph: {
      content: "inline*",
      group: "block",
      parseDOM: [
        {
          tag: "p",
        },
      ],
    },
    listItem: {
      content: "paragraph",
      defining: true,
      parseDOM: [
        {
          tag: "li",
        },
      ],
    },
    doc: {
      content: "block+",
    },
    hardBreak: {
      group: "inline",
      inline: true,
      selectable: false,
      parseDOM: [
        {
          tag: "br",
        },
      ],
    },
    text: {
      group: "inline",
    },
    bulletList: {
      content: "listItem+",
      group: "block list",
      parseDOM: [
        {
          tag: "ul",
        },
      ],
    },
    orderedList: {
      content: "listItem+",
      group: "block list",
      attrs: {
        start: {
          default: 1,
        },
        type: {
          default: null,
        },
      },
      parseDOM: [
        {
          tag: "ol",
        },
      ],
    },
  },
  marks: {
    link: {
      inclusive: false,
      attrs: {
        href: {
          default: null,
        },
        target: {
          default: "_blank",
        },
        rel: {
          default: "noopener noreferrer nofollow",
        },
        class: {
          default: "tiptap-link",
        },
      },
      parseDOM: [
        {
          tag: "a[href]",
        },
      ],
    },
    bold: {
      parseDOM: [
        {
          tag: "strong",
        },
        {
          tag: "b",
        },
        {
          style: "font-weight",
        },
      ],
    },
    italic: {
      parseDOM: [
        {
          tag: "em",
        },
        {
          tag: "i",
        },
        {
          style: "font-style=italic",
        },
      ],
    },
    strike: {
      parseDOM: [
        {
          tag: "s",
        },
        {
          tag: "del",
        },
        {
          tag: "strike",
        },
        {
          style: "text-decoration",
          consuming: false,
        },
      ],
    },
    code: {
      excludes: "bold code italic strike link",
      code: true,
      parseDOM: [
        {
          tag: "code",
        },
      ],
    },
  },
} as const;

export const innerEditorProsemirrorSchema = new Schema(pmSchemaJson);
